export const favoritesEnabled = state => {
  const location =
    state && state.router && state.router.location
      ? state.router.location.search
      : undefined;
  return !!(
    location &&
    location.includes("native=true") &&
    location.includes("platform=web")
  );
};
